import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Category1 from './category';
import Category2 from './category2';
import Category3 from './category3';
import NoUserFound from '../NoUser';
import Category4 from './emotion';
import Category5 from './confession';
import Category8 from './roast';
import Category6 from './hotness';
import Category7 from './friend';
import Category10 from './challenge';
import Category11 from './hellheaven';
import LanguageDropdown from '../Languagedropdown';
import Category12 from './reputation';
import Category13 from './impression';
import Category9Update from './rumour';

const NextPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { username, category } = useParams();

    // Get data from location.state or sessionStorage
    const getStoredData = () => {
        const stateData = location.state;

        // If we have state data, store it and return it
        if (stateData?.originalData) {
            sessionStorage.setItem('originalData', JSON.stringify(stateData.originalData));
            if (stateData.hint) sessionStorage.setItem('hint', stateData.hint);
            if (stateData.uploadedImage) sessionStorage.setItem('uploadedImage', stateData.uploadedImage);
            if (stateData.timestamp) sessionStorage.setItem('timestamp', stateData.timestamp);
            if (stateData.Nouser !== undefined) sessionStorage.setItem('Nouser', JSON.stringify(stateData.Nouser));
            if (stateData.imgLoaded !== undefined) sessionStorage.setItem('imgLoaded', JSON.stringify(stateData.imgLoaded));
            return stateData;
        }

        // Otherwise, retrieve from sessionStorage
        const storedOriginalData = sessionStorage.getItem('originalData');
        if (storedOriginalData) {
            return {
                originalData: JSON.parse(storedOriginalData),
                hint: sessionStorage.getItem('hint') || undefined,
                uploadedImage: sessionStorage.getItem('uploadedImage') || undefined,
                timestamp: sessionStorage.getItem('timestamp') || undefined,
                Nouser: JSON.parse(sessionStorage.getItem('Nouser') || 'null'),
                imgLoaded: JSON.parse(sessionStorage.getItem('imgLoaded') || 'null')
            };
        }

        return {};
    };

    const { hint, uploadedImage, originalData, timestamp, Nouser, imgLoaded } = getStoredData();

    // Get user and lanText
    const user = originalData?.question;

    const subCat = useMemo(() => {
        return Array.isArray(user)
            ? user.find(item => item.category === category)?.answer.subCategory
            : undefined;
    }, [user, category]);


    // Redirect if no data available (AFTER all hooks are called)
    useEffect(() => {
        if (!originalData) {
            navigate(`/${username}/${category}`); // Redirect to home or appropriate page
        }
    }, [originalData, navigate]);

    // Early return AFTER all hooks
    if (!originalData) {
        return null;
    }

    return (
        <div>
            {category === 'V2hvVGFsa2lu' ? (
                <Category1
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                />
            ) : category === 'UGljIFJvYXN0' ? (
                <Category2
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                    timestamp={timestamp}
                />
            ) : category === 'QW5ub3kgZnVuIENhcmQ=' ? (
                <Category3
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                    Nouser={Nouser}
                    imgLoaded={imgLoaded}
                />
            ) : category === 'RW1vdGlvbg==' ? (
                <Category4
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                />
            ) : category === 'Q29uZmVzc2lvbg==' ? (
                <Category5
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                    Nouser={Nouser}
                    imgLoaded={imgLoaded}
                />
            ) : category === 'SG90bmVzcw==' ? (
                <Category6
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                />
            ) : category === 'RnJpZW5k' ? (
                <Category7
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                />
            ) : category === 'Um9hc3Q=' ? (
                <Category8
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                />
            ) : category === 'UnVtb3Vy' ? (
                <Category9Update
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                />
            ) : category === 'Q2hhbGxlbmdl' ? (
                <Category10
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                />
            ) : category === 'SGVhdmVuSGVsbA==' ? (
                <Category11
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                />
            ) : category === 'UmVwdXRhdGlvbg==' ? (
                <Category12
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                />
            ) : category === 'SW1wcmVzc2lvbg==' ? (
                <Category13
                    hint={hint}
                    uploadedImage={uploadedImage}
                    originalData={originalData}
                    username={username}
                    category={category}
                />
            ) : (
                <NoUserFound />
            )}
            <LanguageDropdown subCat={subCat} />
        </div>
    );
};

export default NextPage;